import { reactive } from 'vue';
import { fetchFromLambda } from '@agyletime/vue-3-common/src/utils/apiService';
import { useLogger } from '@agyletime/vue-3-common/src/composables/logger';

const logger = useLogger('activeWsDefOperationConfigRefDataStore');

type WorkstreamDefinitionOperationConfig = {
    _id: string;
    workstreamDefinitionId: number;
    name: string;
    timezone: string;
};

type Store = {
    data: WorkstreamDefinitionOperationConfig[];
    loaded: boolean;
};

const activeWsDefOperationConfigRefDataStore = reactive<Store>({ data: [], loaded: false });

let isInitialized = false;

const fetchData = () => {
    return fetchFromLambda('/workactivity/back-office/workstream-definition-operation-config/active-reference-data')
        .then((response) => {
            activeWsDefOperationConfigRefDataStore.data = response as WorkstreamDefinitionOperationConfig[];
            activeWsDefOperationConfigRefDataStore.loaded = true;
        })
        .catch((error) => {
            logger.error('Error fetching workstream definitions:', error);
        });
};

export const useActiveWsDefOperationConfigRefDataStore = () => {
    if (!isInitialized) {
        isInitialized = true;
        fetchData();
    }

    return {
        activeWsDefOperationConfigRefDataStore,
        refreshActiveWsDefOperationConfigRefDataStore: fetchData
    };
};
